/* SOCIALFUEL: one star system site-wide.
   1. Shape: the review app's stars (product page rating line, review list, featured reviews, home page carousel)
      are redrawn with the theme's own hard-edged star, the one used on the product cards.
   2. Fill: wherever stars stand for an average, they show the real score to one decimal, never rounded up
      (4.9 = four full stars and the fifth filled 90% across). The score comes from the product's review data,
      so it follows new reviews by itself. Stars on a single customer's review are left as given. */
(function () {
  var D = 'M9 0L11.3276 5.79629L17.5595 6.21885L12.7662 10.2237L14.2901 16.2812L9 12.96L3.70993 16.2812L5.23382 10.2237L0.440492 6.21885L6.67237 5.79629L9 0Z';
  function clamp(n) { return Math.max(0, Math.min(1, n)); }
  // product page: the app rounds the average to whole stars, so set the fill from the product's own score
  function fillAverage() {
    var src = document.querySelector('[data-sf-avg]');
    var avg = src ? parseFloat(src.getAttribute('data-sf-avg')) : 0;
    if (!avg) return;
    document.querySelectorAll('.product__info .kl_reviews__star_rating_widget .kl_reviews__stars_badge, .kl_reviews__summary__stars .kl_reviews__stars_badge').forEach(function (badge) {
      badge.querySelectorAll('svg').forEach(function (svg, i) {
        var pct = Math.round(clamp(avg - i) * 100) + '%';
        svg.querySelectorAll('stop[id^="fill-stop"]').forEach(function (s) { if (s.getAttribute('offset') !== pct) s.setAttribute('offset', pct); });
      });
    });
  }
  // home page bundle cards: same rule, using the combined score of the products in the bundle
  function bundleCards() {
    var src = document.getElementById('sf-bundle-ratings'), data;
    if (!src) return;
    try { data = JSON.parse(src.textContent); } catch (e) { return; }
    document.querySelectorAll('a.product-card__title[href*="/products/"]').forEach(function (a) {
      var d = data[a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0]];
      var card = a.closest('.product-card'), box = card && card.querySelector('.product-card__rating');
      if (!d || !box) return;
      var score = Math.floor(d.r * 10 + 1e-9) / 10;
      box.querySelectorAll('svg.rating__star').forEach(function (s, i) {
        var f = clamp(score - i);
        s.classList.toggle('rating__star--transparent', f <= 0);
        s.innerHTML = f > 0 && f < 1
          ? '<path d="' + D + '" fill="#141416" opacity="0.35"/><svg width="' + (Math.round(f * 1800) / 100) + '" height="17"><path d="' + D + '" fill="#141416"/></svg>'
          : '<path d="' + D + '" fill="#141416"/>';
      });
    });
  }
  function fix() {
    fillAverage();
    document.querySelectorAll('svg.kl_reviews__full_star').forEach(function (svg) {
      var p = svg.querySelector('path');
      if (!p || p.getAttribute('d') === D) return;
      svg.setAttribute('viewBox', '0 0 18 17');
      p.setAttribute('d', D);
      p.removeAttribute('stroke');
      p.removeAttribute('stroke-width');
      p.removeAttribute('stroke-linejoin');
    });
  }
  // product page: the gallery opens on its first image, which is not always the flavour that is pre-selected
  // (the first flavour can be sold out). Move it to the selected flavour's first image. Phones and desktop
  // each have their own gallery, so only the one on screen is read and driven.
  function flavourImage() {
    var picked = document.querySelector('.btnflvorshow:checked');
    if (!picked) return true;
    var v = picked.value.trim();
    var shown = function (el) { return el.offsetParent !== null; };
    var cur = Array.prototype.filter.call(document.querySelectorAll('.product-media-carousel__slide.is-selected, .product-media-carousel-mobile__slide.is-selected'), shown)[0];
    if (!cur) return false;
    if ((cur.getAttribute('data-variant') || '').trim() === v) return true;
    var thumbs = Array.prototype.filter.call(document.querySelectorAll('.product-thumbnail-carousel__thumb, .product-thumbnail-carousel-mobile__thumb'), shown);
    for (var i = 0; i < thumbs.length; i++) {
      if ((thumbs[i].getAttribute('data-variant') || '').trim() === v) { thumbs[i].click(); return false; }
    }
    return true;
  }
  // announcement bar: the '15% off your 1st order' line opens the email sign-up form (Klaviyo) that gives the code.
  // The form id is read from the form's own side tab; FORM is the fallback if that tab has been closed.
  function offerBar() {
    var FORM = 'SVHW2B';
    document.querySelectorAll('.announcement-bar__slide').forEach(function (slide) {
      if (slide.dataset.sfOffer || !/15%\s*off/i.test(slide.textContent)) return;
      slide.dataset.sfOffer = '1';
      var t = slide.querySelector('.announcement-bar__rte p') || slide;
      var open = function () {
        var teaser = document.querySelector('[class*="kl-teaser-"]');
        var id = teaser && (String(teaser.className).match(/kl-teaser-([A-Za-z0-9]+)/) || [])[1];
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', id || FORM]);
      };
      t.setAttribute('role', 'button');
      t.setAttribute('tabindex', '0');
      t.style.cursor = 'pointer';
      t.addEventListener('click', open);
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
  }
  function start() {
    fix();
    offerBar();
    var tries = 0, iv = setInterval(function () { if (flavourImage() || ++tries > 12) clearInterval(iv); }, 250);
    var t;
    // reviews load after the page, and more arrive on 'Show more'
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(fix, 50); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  // runs after the home page's own bundle card script, which fills in the review count
  if (document.readyState === 'complete') bundleCards(); else document.addEventListener('DOMContentLoaded', bundleCards);
})();
